import { useEffect } from 'react'
import { apiService } from '../services/api'

export const useStagProcessor = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const stag = params.get('stag')

    if (!stag) return

    apiService.trackStag(stag).catch((error) => {
      console.error('Failed to track stag:', error)
    })

    params.delete('stag')
    const query = params.toString()
    let path = window.location.pathname

    if (query.length > 0) {
      path = `${path}?${query}`
    }

    window.history.replaceState(null, '', path)
  }, [])
}
